function Footer() {
  return (
    <div style={{ background: " rgb(238, 152, 189)" }}>
      <div class="mt-5 pt-5 pb-5 footer">
        <div class="container">
          <div class="row">
            <div class="col-lg-5 col-xs-12 text-white">
              <h4>PERFECT PERFUMES</h4>
              <br />
              <hr></hr>
              <p class="pr-5 text-white-50">
                We come from a place that understands your beauty needs. Beauty
                is all about exchange of tips, inspiration, and expertise, and
                we’ve really evolved into a brand that has transcended past your
                traditional retailer. We care for you and are committed to
                satisfy your needs in most unrivaled ways. Offering you with the
                most exclusive fragrances from top brands such as Yves Saint
                Laurent, Dior, Giorgio Armani, Gucci, Dolce & Gabbana, Carolina
                Herrera and Robert Cavalli. We seek to leave you with an
                unforgettable experience while being emotionally connected in
                every beautiful moment. More than ever, Beauty is about
                self-expression, embracing diversity and experimentation. We
                want to help reveal your uniqueness and give you the tools and
                support to express your beauty.
              </p>

              <p></p>
            </div>
            <div class="col-lg-3 col-xs-12 links">
              <h4 class="mt-lg-0 mt-sm-3 text-white">WORKING HOURS</h4>
              <br />
              <hr class="text-white-50"></hr>
              <p class=" text-white-50">Monday : 10AM – 9PM</p>
              <p class=" text-white-50">Tuesday : 10AM – 9PM</p>
              <p class=" text-white-50">Wednesday : 10AM – 9PM</p>
              <p class=" text-white-50">Thursday : 10AM – 9PM </p>
              <p class=" text-white-50">Friday : 10AM – 9PM</p>
              <p class=" text-white-50">Saturday : 10AM – 5PM</p>
              <p class=" text-white-50">Sunday : 10AM – 5PM</p>
            </div>
            <div class="col-lg-4 col-xs-12 location">
              <h4 class="mt-lg-0 mt-sm-4 text-white">CUSTOMER SERVICE</h4>
              <br />
              <hr class="text-white-50"></hr>
              <a href="#contact" class=" text-white-50">
                Contact Us
              </a>
              <p class="mb-0  text-white-50">
                <a href="#contact" class="fa fa-phone mr-3 text-white-50">
                  FAQs
                </a>
              </p>
              <br></br>
              <br></br>
              <h4 class="mt-lg-0 mt-sm-4 text-white">Social Media </h4>
              <hr class="text-white-50"></hr>
              <a href="#contact" class=" text-white-50">
                Twitter
              </a>
              <p class="mb-0  text-white-50">
                <a href="#contact" class="fa fa-phone mr-3 text-white-50">
                  Instagram
                </a>
              </p>
              <p class="mb-0  text-white-50">
                <a href="#contact" class="fa fa-phone mr-3 text-white-50">
                  Snapchat
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="header1">
        <p class="header-text1">@ Create with Love by Amirah 💕 </p>
      </div>
    </div>
  );
}

export default Footer;
